var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pb-4 m-4"},[_c('b-row',{staticClass:"match-height"},[_c('b-col',{attrs:{"xl":"12","md":"12","sm":"12"}},[_c('transacciones',{attrs:{"frompublic":true}})],1)],1),_c('hr')],1)}
var staticRenderFns = []

export { render, staticRenderFns }